import { cx } from "cva";
import { SidecarBlock } from "~/components/Sidecar/sidecar-schemas";
import { SidecarBlocks } from "~/components/Sidecar/SidecarBlocks";
import { SidecarContainer } from "~/components/Sidecar/SidecarContainer";

export type SidecarProps = {
  blocks?: SidecarBlock[];
  isLoading: boolean;
  isValidating: boolean;
};

const containerClass =
  "md:max-w-[280px] md:min-w-[280px] border-t-2 first:border-t-0 border-b-gray-300 border-t-brand";

const LoadingBar: React.FC<{
  className: string;
  children?: React.ReactNode;
}> = ({ children, className }) => (
  <div className="w-full">
    <div className={cx("h-[2px] w-full overflow-hidden", className)}>
      {children}
    </div>
  </div>
);

export const Sidecar: React.FC<SidecarProps> = ({
  isLoading,
  isValidating,
  blocks,
  ...rest
}) => {
  if (!blocks?.length || isLoading || isValidating) {
    return (
      <div className={containerClass} {...rest} data-testid="sidecar-loader">
        <LoadingBar className="bg-brand-teal-100">
          <div className="h-full w-full origin-left-right animate-progress bg-brand-teal"></div>
        </LoadingBar>
        <div>
          <SidecarContainer className="flex w-full justify-center">
            <div />
          </SidecarContainer>
        </div>
      </div>
    );
  }
  return (
    <aside className={containerClass} {...rest}>
      <LoadingBar className="bg-brand-teal" />
      <div>
        <SidecarBlocks blocks={blocks} />
      </div>
    </aside>
  );
};
